import { useMemo, useState } from 'react';
import { PolicySearchDataGrid } from '@pages/Policies/policyDataGrid/policySearch/PolicySearchDataGrid';
import { getColumnsBase } from '@pages/Policies/policyDataGrid/PolicyDataGrid.constants';
import { TabOptions, Tabs, TabPanel } from '@components/tabs';
import { Layout } from '@layout/Layout';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';
import { usePolicyMetadata } from '@services/policy';
import { PagePadding } from '@layout/Layout.constants';
import { ClockFormat } from '@lio/rule-engine';

const PoliciesTab = {
  AllPolicies: 1,
};

export const PoliciesPage = () => {
  const { isLoading } = usePolicyMetadata();
  const [userAuth, layoutPreferences] = useStore((state) => [state.userAuth, state.layoutPreferences], shallow);
  const { isInternalUser } = userAuth;
  const clockFormat = layoutPreferences.clockFormat as unknown as ClockFormat;
  const [tabValue, setTabValue] = useState<number>(PoliciesTab.AllPolicies);

  const tabs: TabOptions[] = [
    {
      value: PoliciesTab.AllPolicies,
      label: 'All Policies',
    },
  ];

  const handleChange = (_: unknown, newValue: number) => {
    setTabValue(newValue);
  };

  const columns = useMemo(() => {
    return getColumnsBase({
      isInternalUser,
      userConfig: { layoutPreferences: { clockFormat } },
    })?.filter((c) => c.isVisible?.({ isInternalUser }) ?? true);
  }, [isInternalUser, clockFormat]);

  return (
    <Layout
      title='Policies'
      config={{
        padding: PagePadding.TABLE_LIST_PAGE,
      }}
    >
      <Tabs tabOptions={tabs} value={tabValue} onChange={handleChange} />
      <TabPanel selectedTab={tabValue} value={PoliciesTab.AllPolicies}>
        <PolicySearchDataGrid isLoading={isLoading} columns={columns} />
      </TabPanel>
    </Layout>
  );
};

export default PoliciesPage;
